// Mock data for FlexiOss Landing Page

export const heroData = {
  title: "FlexiOss®",
  subtitle: "Revolutionary Bone Regeneration Technology",
  description: "Next-generation implantable biomaterial engineered for advanced bone defect filling and regenerative medicine.",
  certifications: [
    { label: "FlexiOss® Ortho", code: "CMDR-2025-04943A" },
    { label: "FlexiOss® Dent", code: "CMDR-2025-04943B" }
  ],
  badges: ["Bioactive", "Osteoconductive", "Osteogenic", "Regenerative"]
};

export const compositionData = [
  {
    id: 1,
    name: "Hydroxyapatite Matrix",
    property: "Osteoconductive",
    percentage: 60,
    description: "Mimics natural bone mineral structure for optimal integration"
  },
  {
    id: 2,
    name: "β-1,3-Glucan Polymer",
    property: "Bioactive matrix",
    percentage: 35,
    description: "Advanced polymer supporting cellular activity"
  },
  {
    id: 3,
    name: "Bioactive Additives",
    property: "Osteogenic factors",
    percentage: 5,
    description: "Essential growth factors for bone formation"
  }
];

export const technicalSpecs = [
  { label: "Porosity", value: "65-75%", icon: "grid-3x3" },
  { label: "Pore Size", value: "100-500μm", icon: "maximize" },
  { label: "Resorption", value: "6-24 months", icon: "clock" }
];

export const clinicalFeatures = [
  {
    id: 1,
    phase: "In Vitro Studies",
    title: "Cellular Biocompatibility",
    description: "Conducted at Medical University of Lublin, Chair and Department of Biochemistry and Biotechnology.",
    findings: [
      "Non-toxic against human fetal osteoblasts",
      "Biomaterial ion reactivity on cell viability",
      "Published in scientific journals"
    ]
  },
  {
    id: 2,
    phase: "Animal Studies",
    title: "Pre-clinical Evaluation",
    description: "Pre-clinical evaluation at Animal Surgery Clinic, University of Life Sciences in Lublin.",
    findings: [
      "Tested in dogs, cats, and laboratory rabbits",
      "No inflammatory reactions observed",
      "Confirmed biocompatibility"
    ]
  },
  {
    id: 3,
    phase: "Human Clinical Studies",
    title: "Clinical Applications",
    description: "Clinical observations at Department of Trauma Surgery and Emergency Medicine, Medical University of Lublin.",
    findings: [
      "Comminuted fractures treatment",
      "Dental bone defect augmentation",
      "No side effects or allergic reactions"
    ]
  }
];

export const clinicalResults = {
  histological: [
    "Presence of bone cells and laminae",
    "Formation of collagen fibres",
    "Development of Haversian canals",
    "Active bone tissue formation"
  ],
  applications: [
    "Long bone defect filling",
    "Dental extraction site augmentation",
    "Oronasal fistulae treatment",
    "Bone tissue regeneration"
  ]
};

export const certifications = [
  {
    id: 1,
    title: "CE Certified",
    code: "EC Certificate No. 1434-MDD-269/2021",
    description: "Ensuring highest safety and quality standards"
  },
  {
    id: 2,
    title: "PH-FDA Approved",
    code: "CMDR-2025-04943A/B",
    description: "Certified for orthopedic, dental & veterinary applications"
  },
  {
    id: 3,
    title: "Patent Protected",
    code: "European Patents",
    description: "Protected across England, Germany, France, and Poland"
  }
];

export const distributorInfo = {
  name: "Fortschritt Medical Supplies Inc.",
  tagline: "Philippine Exclusive Distributor",
  description: "Your trusted partner for FlexiOss® in the Philippines. Contact us for product inquiries, orders, and technical support.",
  contact: {
    email: "fms.medequip@gmail.com",
    phones: [
      { type: "Globe", number: "+63915-3752-892" },
      { type: "Sun", number: "+63922-8005-509" }
    ],
    mainAddress: "Lot 2 Blk 7 Norwalk St. Northmadison, First Bulacan Industrial City, Malolos City of Bulacan, Philippines 3000",
    satelliteAddress: "Orean Place Tower 2, Unit 503, Terra Drive cor. Stella Drive, Vertis North Estate, Brgy. Bagong Pagasa, Quezon City, Philippines 1105"
  }
};

// Testimonials removed as per client request
